import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DatePicker } from 'antd-v5';
import dayjs, { Dayjs } from 'dayjs';
import { theme } from 'styles';

interface RangePickerProps {
  onChange: (dateStrings: [string, string]) => void;
  value?: [string, string];
  className?: string;
  allowClear?: boolean;
  disabled?: boolean;
}

const RangePicker = ({ onChange, value, className, allowClear = true, disabled = false }: RangePickerProps) => {
  const { t } = useTranslation();
  const [range, setRange] = useState<[Dayjs, Dayjs] | null>(null);

  useEffect(() => {
    if (!value) {
      return;
    }
    if (value?.[0] && value?.[1]) {
      setRange([dayjs(value[0]), dayjs(value[1])]);
    } else {
      setRange(null);
    }
  }, [value]);

  return (
    <DatePicker.RangePicker
      placeholder={[t('common.date.start_date', 'Start date'), t('common.date.end_date', 'End date')]}
      className={className}
      allowClear={allowClear}
      disabled={disabled}
      allowEmpty={disabled ? [true, true] : undefined}
      style={{ width: '100%', border: `solid 1px ${theme.color.grey55}`, borderRadius: '4px' }}
      value={range}
      onChange={(dates, dateStrings) => {
        if (dates?.[0] && dates?.[1]) {
          setRange([dates[0], dates[1]]);
        } else {
          setRange(null);
        }
        onChange(dateStrings);
      }}
    />
  );
};

export default RangePicker;
